import React, { useState, useRef, useEffect } from 'react';
import DetectDevice from './DeviceDetector';
import { useMap } from 'react-leaflet/hooks';
import { IoIosClose, IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';
import { BsInstagram, BsTwitter, BsTiktok } from 'react-icons/bs';
import '../styles/information.css';
import { isSafari } from 'react-device-detect';
import { useSelector } from 'react-redux';
import {
  IoIosAdd,
  IoIosRemove,
  IoIosArrowUp,
  IoIosArrowDown,
} from 'react-icons/io';
import '../styles/listview.css';
import token_dict from '../data/token_dict.json';
import ownership_full from '../data/availability_list.json';
import { Alchemy, Network } from 'alchemy-sdk';
import contract from './redux/config/config.json';
import { selectQueried } from './MyMap.js';
import polygonJson from '../data/geo_json_string.json';
import { useDispatch } from 'react-redux';
import { fetchData } from './redux/data/dataActions';
import Web3 from 'web3';

const contractABI = require('./contract-abi.json');
const tokenContractABI = require('./token-abi.json');

const { createAlchemyWeb3 } = require('@alch/alchemy-web3');

var alch_network;
var alch_key;
var alchemyKey;
var contractAddress;
var tpx_address; 

if (contract.NETWORK.ID == 1) {
  // Initialization
  alch_key = contract.ALCH_KEY;
  alch_network = Network.ETH_MAINNET;
  alchemyKey = contract.ALCH_KEY_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS);
  tpx_address = String(contract.TPX_ADDRESS);
}
if (contract.NETWORK.ID == 5) {
  // Initialization
  alch_key = contract.ALCH_KEY_TEST;
  alch_network = "eth-sepolia"; //Network.ETH_SEPOLIA;
  alchemyKey = contract.ALCH_KEY_TEST_LINK;
  contractAddress = String(contract.CONTRACT_ADDRESS_GOERLI);
  tpx_address = String(contract.TPX_ADDRESS_GOERLI);
}

const alc_config = {
  apiKey: alch_key,
  network: alch_network,
};
const alchemy = new Alchemy(alc_config);
const alch_web3 = createAlchemyWeb3(alchemyKey);

let arr = [];
for (let i = 0; i < 1000; i++) {
  arr.push(i);
}

export const Info_claim = ({
  setProjectInfo,
  setSidebar,
  masterTile,
  currentPrompt,
  gridOverlay,
  setMasterTile,
  setSidebarTitle,
  ownershipUpdated,
  setCurrentPrompt,
  setTilePreview,
  listViewExpanded,
  setlistViewExpanded,
  mintMessage,
  setMintMessage,
  setRevertMessage,
  ownership,
  setOwnership,
  DetectDevice,
  currFetchingItems,
  setCurrFetchingItems,
}) => {
  const [expandables, setExpandables] = useState([1, 0, 0, 0, 0, 0, 0]);
  const map = useMap();
  //init state variables
  const blockchain = useSelector((state) => state.blockchain);
  const [selectedItem, setSelectedItem] = useState(null);
  const [mousedOverItem, setMousedOverItem] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('Yours');
  const [totalClaim, setTotalClaim] = useState(0);
  const [totalTPXforCalc, setTotalTPXforCalc] = useState(0);
  const [itemsToClaim, setItemsToClaim] = useState([]);
  const [itemsFullList, setItemsFullList] = useState([]);
  const [items, setItems] = useState([]);
  const [itemsPerClass, setItemsPerClass] = useState([0,0,0,0]);
  const [sortAscending, setSortAscending] = useState(false);
  const [mintedPixelCount, setMintedPixelCount] = useState(0);
  const [mintedNFTCount, setMintedNFTCount] = useState(0);
  const [mintedTPXCount, setTPXCount] = useState(0);
  const dispatch = useDispatch();
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: '',
    SCAN_LINK: '',
    NETWORK: {
      NAME: '',
      SYMBOL: '',
      ID: 0,
    },
    NFT_NAME: '',
    SYMBOL: '',
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: '',
    MARKETPLACE_LINK: '',
    SHOW_BACKGROUND: false,
  });

  const selectQueriedClone = ({
    map,
    gridOverlay,
    sidebarState,
    setMasterTile,
    setSidebarTitle,
    shouldZoom,
    queryNumObject,
    setTilePreview,
  }) =>
    selectQueried({
      map,
      gridOverlay,
      sidebarState,
      setMasterTile,
      setSidebarTitle,
      shouldZoom,
      queryNumObject,
      setTilePreview,
    });

  function setLink(curTile) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://opensea.io/assets/ethereum/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://testnets.opensea.io/assets/goerli/';
    }
    let link_with_contract = link_base.concat(String(contractAddress));
    let link2 = link_with_contract.concat('/');
    let full_link = link2.concat(curTile);
    return full_link;
  }

  useEffect(() => {
    var urlId = '/todem/info';
    window.history.pushState('', '', '' + urlId);
    return () => {
      var urlId = '/todem/';
      window.history.pushState('', '', '' + urlId);
      let tileNum = masterTile.masterTile.name;
      if (!isNaN(Number(tileNum.split('-')[1]))) {
        urlId += tileNum.split('-')[1].padStart(4, '0');
        if (currentPrompt) {
          urlId += '.' + currentPrompt[0];
        }
        window.history.pushState('', '', '' + urlId);
      }
    };
  }, []);

  //const map = useMap();

  map.smoothWheelZoom.disable();
  map.scrollWheelZoom.disable();
  map.dragging.disable();

  // This is the color that fills notch space on mobile
  useEffect(() => {
    document.body.style.backgroundColor = 'white';
    return () => {
      document.body.style.backgroundColor = 'white';
    };
  });

  //This function is deprecated but shouldnt yet be deleted
  //fetches user nfts directly by making a call to alchemy
  async function fetchCurrUserNFTs(addr) {
    let web3;
    web3 = new Web3(window.ethereum);
    let nfts;
    const currWallet = String(addr); //String(blockchain.account);
    var requestOptions = {
      method: 'GET',
    };

    if (currWallet !== '' && currWallet !== 'null') {
      nfts = await alchemy.nft.getNftsForOwner(currWallet);
    }
    //let i = 1;
    /*
    if (nfts) {
      for (let nft of nfts.ownedNfts) {
        if (
          nft.contract.address.toLowerCase() === contractAddress.toLowerCase()
        ) {
          //let strTokenId = web3.utils.hexToNumberString(String(nft.id.tokenId));
          ownership[nft.tokenId] = 2;
          //i++;
        }
      }
    }*/
    const promises = nfts.ownedNfts.map(async (nft) => {
      const num_padded = Object.keys(token_dict).find(key => token_dict[key] === parseInt(nft.tokenId));
      let color = "";
      if(num_padded){
        if(polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1] == 'A'){
          color = "rgba(204, 102, 102, 0.1)";
        }
        if(polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1] == 'B'){
          color = "rgba(249, 228, 120, 0.1)";
        }
        if(polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1] == 'C'){
          color = "rgba(120, 172, 249, 0.1)";
        }
        if(polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1] == 'D'){
          color = "rgba(211, 211, 211, 0.1)";
        }
      }
      return  (num_padded && nft.contract.address.toLowerCase() === contractAddress.toLowerCase())
        ? {
            image: `https://www.latentculture.com/tohm/thumbs/TODEM.thumb.${num_padded}.jpg`,
            name: num_padded,
            class: polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1],
            color: color,
          }
        : null;
    });
    var items = await Promise.all(promises);
    items = items.filter((item) => item !== null);
    let i = 1;
    var itemsTemp = [];
    var fullItemsTemp = [];
    let classAPixels = 0;
    let classBPixels = 0;
    let classCPixels = 0;
    let classDPixels = 0;
    for (let item of items) {
        let claim = await hasBeenClaimed(token_dict[item.name]);
        if(!claim){
          //console.log(item.class, token_dict[item.name])
          if(item.class == 'A'){
            classAPixels = classAPixels + token_dict[item.name];
          }
          else if(item.class == 'B'){
            classBPixels = classBPixels + token_dict[item.name];
          }
          else if(item.class == 'C'){
            classCPixels = classCPixels + token_dict[item.name];
          }
          else if(item.class == 'D'){
            classDPixels = classDPixels + token_dict[item.name];
          }
          itemsTemp.push(token_dict[item.name]);
        }
        fullItemsTemp.push(token_dict[item.name]);
        i++;
    }
    setItemsPerClass([classAPixels, classBPixels, classCPixels, classDPixels])
    setItemsToClaim(itemsTemp);
    setItemsFullList(fullItemsTemp);
    items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name)); // Sort items
    items.sort((a, b) => {
      // Check if token_dict[a.name] exists in itemsTemp
      let aExists = itemsTemp.includes(token_dict[a.name]) ? 0 : 1;
      // Check if token_dict[b.name] exists in itemsTemp
      let bExists = itemsTemp.includes(token_dict[b.name]) ? 0 : 1;

      return aExists - bExists;
    });  

    //if(!itemsFetched){
    setItems(items);
    //}
  }

  //Fetches user NFTs assuming the topbar check worked and we can just go based on ownership dict
  async function fetchItems() {
    const promises = arr.map(async (num) => {
      let num_padded = num.toString().padStart(4, '0'); 
      let color = "";
      let status =
        ownership[token_dict[num_padded]] === 0
          ? 'Uminted'
          : ownership[token_dict[num_padded]] === 1
          ? 'Minted'
          : ownership[token_dict[num_padded]] === 2
          ? 'Yours'
          : 'Unknown';
      if(polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1] == 'A'){
        color = "rgba(204, 102, 102, 0.1)";
      }
      if(polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1] == 'B'){
        color = "rgba(249, 228, 120, 0.1)";
      }
      if(polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1] == 'C'){
        color = "rgba(120, 172, 249, 0.1)";
      }
      if(polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1] == 'D'){
        color = "rgba(211, 211, 211, 0.1)";
      }
      return (selectedStatus === status)
        ? {
            image: `https://www.latentculture.com/tohm/thumbs/TODEM.thumb.${num_padded}.jpg`,
            name: num_padded,
            class: polygonJson.features[0].features[parseInt(num_padded)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1],
            color: color,
          }
        : null;
    });
    var items = await Promise.all(promises);
    items = items.filter((item) => item !== null);
    let i = 1;
    var itemsTemp = [];
    var fullItemsTemp = [];
    let classAPixels = 0;
    let classBPixels = 0;
    let classCPixels = 0;
    let classDPixels = 0;
    for (let item of items) {
        let claim = await hasBeenClaimed(token_dict[item.name]);
        if(!claim){
          //console.log(item.class, token_dict[item.name])
          if(item.class == 'A'){
            classAPixels = classAPixels + token_dict[item.name];
          }
          else if(item.class == 'B'){
            classBPixels = classBPixels + token_dict[item.name];
          }
          else if(item.class == 'C'){
            classCPixels = classCPixels + token_dict[item.name];
          }
          else if(item.class == 'D'){
            classDPixels = classDPixels + token_dict[item.name];
          }
          itemsTemp.push(token_dict[item.name]);
        }
        fullItemsTemp.push(token_dict[item.name]);
        i++;
    }
    setItemsPerClass([classAPixels, classBPixels, classCPixels, classDPixels])
    setItemsToClaim(itemsTemp);
    setItemsFullList(fullItemsTemp);
    items.sort((a, b) => (sortAscending ? b.name - a.name : a.name - b.name)); // Sort items
    items.sort((a, b) => {
      // Check if token_dict[a.name] exists in itemsTemp
      let aExists = itemsTemp.includes(token_dict[a.name]) ? 0 : 1;
      // Check if token_dict[b.name] exists in itemsTemp
      let bExists = itemsTemp.includes(token_dict[b.name]) ? 0 : 1;

      return aExists - bExists;
    });  

    setItems(items);
    return items
  }

  //function to tpx. Alchemy used to estimate gas, then parameters are set for eth_sendTransaction.
  //eth_sendTransaction is then sent with whichever provder is connects. Likely metamask. 
  async function claimTPX() {
    if(blockchain.account !== "" && blockchain.account !== null){
      if(itemsToClaim.length > 0){
        window.contract = await new alch_web3.eth.Contract(
          tokenContractABI,
          tpx_address 
        );

        //const gasPrice = await alch_web3.eth.getGasPrice();
        //const baseFee = await alch_web3.eth.getBlock('latest').then(block => block.baseFeePerGas);
        //const priorityFee = Web3.utils.toWei('2', 'gwei'); // Example priority fee
        //const maxFeePerGas = Web3.utils.toBN(baseFee).add(Web3.utils.toBN(priorityFee)).toString();
        //determine gas estimate
        const gasEstimate = await window.contract.methods.claimTokens(itemsToClaim).estimateGas({ from: blockchain.account });
        //console.log("0x" + String(Number(gasEstimate).toString(16)))
        const transactionParameters = {
            //gas: String(gasEstimate),
            //gasPrice: String(gasPrice),
            gas: "0x" + String(Number(gasEstimate).toString(16)), //convert to right notation
            to: tpx_address, // Required except during contract publications.
            from: blockchain.account, // must match user's active address.
            'data': window.contract.methods.claimTokens(itemsToClaim).encodeABI(), //make call to NFT smart contract 
        };
        //sign transaction via Metamask
        try {
            setMintMessage('claimingTPX');
            const txHash = await window.ethereum
                .request({
                    method: 'eth_sendTransaction',
                    params: [transactionParameters],
                });
            return {
                txn: txHash, 
                success: true,
                status: "✅ Check out your transaction on Etherscan: https://etherscan.io/tx/" + txHash
            }
        } catch (error) {
            setMintMessage('err');
            setRevertMessage(error.message);
            return {
                success: false,
                status: "😥 Something went wrong: " + error.message
            }
        }
      }else{
        setMintMessage('err');
        setRevertMessage("no TPX to claim"); 
      }
    }
    else{
      setMintMessage('no_wallet');
      setRevertMessage(
        'Connect your ethereum wallet via the connect wallet dropdown before claiming'
      );
    }
  }
  //Call to tpx contract to determine if token has been claimed
  async function hasBeenClaimed(tokenId) {
      window.contract = await new alch_web3.eth.Contract(
        tokenContractABI,
        tpx_address
      ); 
      let claimed = await window.contract.methods
        .tokenClaimed(tokenId)
        .call();
      return claimed
  }

  function calculateTotalTPXValue(items){
    var total_value = 0;
    for (let token of items) {
        var value = Math.floor(token / 10) * 10;  
        value = value * 0.001;
        if(token >=73359200){
            value=value*4;
        }
        else if(token >=8954400){
            value=value*3;
        }
        else if(token >=1496400){
            value=value*2;
        }else{
            value=value*1;
        }
        total_value = total_value + value;
    }
    setTotalTPXforCalc(total_value);
  }
  function calculateClaimValue(items){
    var total_value = 0;
    for (let token of items) {
        var value = Math.floor(token / 10) * 10;  
        value = value * 0.001;
        if(token >=73359200){
            value=value*4;
        }
        else if(token >=8954400){
            value=value*3;
        }
        else if(token >=1496400){
            value=value*2;
        }else{
            value=value*1;
        }
        total_value = total_value + value;
    }
    setTotalClaim(total_value);
  }

  function betterGetCirculatingSupply(){
    let i = 1;
    let mintedNFTs = 0;
    let pixelCount = 0;
    let TPXcount = 0;
    let maxTotalPixels = 17319472495;
    for (const tokenid in ownership) {
        if (ownership[tokenid] !== 0) { // Check if the value is non-zero
          pixelCount = pixelCount + parseInt(tokenid);
          mintedNFTs = mintedNFTs + 1;
          if(tokenid >=73359200){
              TPXcount=TPXcount+tokenid*4;
          }
          else if(tokenid >=8954400){
              TPXcount=TPXcount+tokenid*3;
          }
          else if(tokenid >=1496400){
              TPXcount=TPXcount+tokenid*2;
          }else{
              TPXcount=TPXcount+tokenid*1;
          }         
        }
    }
    //console.log(pixelCount,maxTotalPixels)
    setMintedPixelCount(pixelCount/maxTotalPixels);
    setMintedNFTCount(mintedNFTs);
    setTPXCount(TPXcount* 0.001);
    //console.log(mintedTPXCount, mintedPixelCount)
  } 
  function setContractLink(Address) {
    var link_base = '';
    if (contract.NETWORK.ID == 1) {
      link_base = 'https://etherscan.io/address/';
    }
    if (contract.NETWORK.ID == 5) {
      link_base = 'https://goerli.etherscan.io/address/';
    }
    let full_link = link_base.concat(Address);
    return full_link;
  }

  async function getCirculatingSupply(){
    const address = String(contractAddress);
    const { nfts } = await alchemy.nft
      .getNftsForContract(address, {
        omitMetadata: false,
      })
      .catch((e) => console.log(e));

    const opts = {
      pageKey: '1000',
      omitMetadata: false,
      pageSize: 10,
      tokenUriTimeoutInMs: 0,
    };
    let i = 1;
    let mintedNFTs = 0;
    let pixelCount = 0;
    let TPXcount = 0;
    let maxTotalPixels = 17319472495;
    for await (const nft of alchemy.nft.getNftsForContractIterator(
      address,
      opts
    )) {
      pixelCount = pixelCount + parseInt(nft.tokenId);
      mintedNFTs = mintedNFTs + 1;
      if(nft.tokenId >=73359200){
          TPXcount=TPXcount+nft.tokenId*4;
      }
      else if(nft.tokenId >=8954400){
          TPXcount=TPXcount+nft.tokenId*3;
      }
      else if(nft.tokenId >=1496400){
          TPXcount=TPXcount+nft.tokenId*2;
      }else{
          TPXcount=TPXcount+nft.tokenId*1;
      }
    };
    setMintedPixelCount(pixelCount/maxTotalPixels);
    setMintedNFTCount(mintedNFTs);
    setTPXCount(TPXcount* 0.001);
  } 

  useEffect(() => {
    if (selectedItem != masterTile.masterTile.name.split('-')[1]) {
      setSelectedItem(null);
    }
  }, [masterTile]);


  useEffect(() => {
    setCurrFetchingItems(true);
    const fetchAndSetItems = async () => {
      try {
          let itemsuser = await fetchItems(); // Wait for fetchItems to complete
      } catch (error) {
        console.error("Failed to fetch items:", error);
        // Optionally, handle any errors, such as setting an error state
      }
    };

    fetchAndSetItems();
  }, [ownership]);
  /*
  useEffect(() => {
    const fetchAndSetItems = async () => {
      try {
        if (blockchain.account !== '' && blockchain.account !== null){
          fetchCurrUserNFTs(blockchain.account);
        }
        else{
          setItems([])
          setItemsToClaim([])
          setItemsPerClass([0,0,0,0])
          setItemsFullList([])
        }
      } catch (error) {
        console.error("Failed to fetch items:", error);
        // Optionally, handle any errors, such as setting an error state
      }
    };

    fetchAndSetItems();
  }, [blockchain.account]);*/

  useEffect(() => {
    calculateClaimValue(itemsToClaim);
    calculateTotalTPXValue(itemsFullList);
    setCurrFetchingItems(false);
  }, [itemsToClaim, itemsFullList]);

  useEffect(() => {
    setCurrFetchingItems(false);
  }, [totalClaim]);
  

  const getData = () => {
    if (blockchain.account !== '' && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };
  const getConfig = async () => {
    SET_CONFIG(contract);
  };

  useEffect(() => {
    getConfig();
    betterGetCirculatingSupply();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  const MathJaxComponentMobile = ({ content }) => {
    useEffect(() => {
      if (window.MathJax) {
        window.MathJax.typesetPromise().catch((err) => console.error('Typeset failed:', err));
      }
    }, [content]); // Re-typeset when content changes

    return (
      <div style={{width: "0", fontSize: "12px"}}>
        <span dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };
  const MathJaxComponent = ({ content }) => {
    useEffect(() => {
      if (window.MathJax) {
        window.MathJax.typesetPromise().catch((err) => console.error('Typeset failed:', err));
      }
    }, [content]); // Re-typeset when content changes

    return (
      <div>
        <span dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  };

  function formatNumberWithFixedDecimalsAndLocale(number, decimalPlaces = 2) {
    const fixedNumber = Number(number).toFixed(decimalPlaces);

    let [integerPart, decimalPart] = fixedNumber.split('.');

    integerPart = Number(integerPart).toLocaleString();

    return `${integerPart}.${decimalPart}`;
  }

  return (
      <>
      <div class="grid-container-claim-wrapper" style={{display: !DetectDevice ? "grid" : "block", 'grid-auto-flow': !DetectDevice ? "row" : "none", alignItems: "center", justifyContent: "space-around"}}>
      <h5>TPX Claim</h5>
          <div className="info-line-container">
            <span className="info-line"></span>
          </div>
      <div className ="grid-item-claim" style={{display: !DetectDevice ? "flex" : "block", alignItems: "center", justifyContent: "space-around", marginTop: "20px", 'z-index': "999"}}>
      <div className={!DetectDevice ? "claim_text" : "claim_text_mobile"} style={{alignItems: "center", justifyContent: "space-around", fontSize: "15px"}}>
          <p style={{paddingBottom: DetectDevice ? "50px" : "0px"}}> TPX or “TODEM Pixels” extends the <i>TODEM</i> artwork. Tile holders can claim TPX tokens for free, proportional to the pixel count of their Tile. Additionally, the amount of TPX received is boosted by a class-based multiplier. 
          <br></br>
          {!DetectDevice ?
          <MathJaxComponent content={`\\[
          \TPX = \\text{\Tile Pixels} \\cdot \\frac{1\\, \TPX}{1000\\, \\text{pixels}} \\cdot 
          \\begin{cases} 
          \\text{4  if Class} = A \\\\
          \\text{3  if Class} = B \\\\
          \\text{2  if Class} = C \\\\
          \\text{1  if Class} = D
          \\end{cases}
        \\]`} />
          : 
          <MathJaxComponentMobile content={`\\[
          \TPX = \\text{\Tile Pixels} \\cdot \\frac{1\\, \TPX}{1000\\, \\text{pixels}} \\cdot 
          \\begin{cases} 
          \\text{4  if Class} = A \\\\
          \\text{3  if Class} = B \\\\
          \\text{2  if Class} = C \\\\
          \\text{1  if Class} = D
          \\end{cases}
        \\]`} />
          }          
          <br></br> 
          The TPX liquidity pool was established on February 29, 2024 by Jason Salavon. Notably, he minted two significant Tiles: TODEM.0007 (Titanic) and TODEM.0017 (Andy Kaufman). To seed the liquidity pool, he contributed their 822,415.20 TPX alongside 0.5425055 ETH (1% of those Tiles' retail mint price).
          <br></br> 
          <div style={{textAlign:"center"}} id="zerobr">contract address: 
          <span 
            onClick={() => {
              window.open(
                setContractLink(tpx_address),
                '_blank'
              );}}
            style={{ cursor: 'pointer', color: "#60FD2D", fontSize: !DetectDevice ? "15px" : "12px"}}
          > {tpx_address}</span>
          {/*<br></br> 
          <u>uniswap</u> <u>chart</u> */}
          </div>
          <br></br> 
          Currently, {mintedNFTCount} <i>TODEM</i> Tiles have been minted accounting for {Number(mintedPixelCount*100).toFixed(2)}% of total pixels in the Tapestry. This creates a circulating supply of {formatNumberWithFixedDecimalsAndLocale(mintedTPXCount)} TPX. Max total supply, if all Tiles are minted, is 17,319,472.50 TPX.
          </p>
      </div>
      </div>
      {!DetectDevice ? (
      <>
      <div className ="grid-item-claim" style={{display: "flex", alignItems: "center", justifyContent: "space-around", 'z-index': "1"}}>
          <div className="claim_background" style={{alignItems: "center", justifyContent: "space-around"}}>
            <div className="claim-left" style={{display:"inline-block", width:"63px", transform:"translate(3px, -10px)"}}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="100%"
              viewBox="0 0 63 63"
              fill="none"
            >
              <path
                d="M26.7402 8.58883V21.614H18.0334V25.9096H26.7402V32.0989H20.6593V35.1781H26.7402V46.6945L31.8537 51.96H44.0156V47.803L32.1301 46.4866L31.4086 35.1781H37.5508V32.0989H31.2121L30.8172 25.9096H39.6622V21.614H31.0245V8.58883H26.7402Z"
                fill="white"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_182_273"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(3 5.4634) rotate(43.4023) scale(68.9015 67.7974)"
                >
                  <stop offset="0.322917" stopColor="#FEBE32" />
                  <stop offset="1" stopColor="#9C59EF" />
                </radialGradient>
              </defs>
            </svg>
            </div>
            <div className="claim-right" style={{display:"inline-block", width:"70%"}}>
              <div style={{"textAlign":"center", marginTop:"4px", color:'#dcdcdc', fontStyle: 'normal', fontWeight:'700', letterSpacing: 'min(.1dvw,.1dvh)', fontSize:'22px', 'font-family':"Terminus"}}><span style={{color: "yellow"}}>{Number(totalClaim).toFixed(2)} </span>TPX</div>
              <div className="tpx_claim_button" style={{fontStyle:"none", cursor: "pointer", margin:"auto", marginTop:"0px"}}  
                onClick={(e) => {
                  claimTPX().then(response => {
                    if (response.success) {
                      console.log(response.txn);
                      // Use a loop to periodically check for the transaction receipt
                      const checkReceipt = setInterval(() => {
                        alch_web3.eth.getTransactionReceipt(response.txn, function(err, receipt) {
                          if (receipt) {
                            clearInterval(checkReceipt); // Stop checking once the receipt is found
                            console.log(receipt);
                            if (!err && receipt.status) { // Check if the transaction was successful
                              console.log("Transaction successful");
                              setMintMessage('claimedTPX');
                              setRevertMessage(Number(totalClaim).toFixed(2));
                              fetchItems();
                            } else {
                              setMintMessage('err');
                              setRevertMessage("transaction failed");
                            }
                          } else if (err) {
                            clearInterval(checkReceipt); // Stop checking if there's an error
                            console.error("Error fetching transaction receipt:", err.message);
                            setMintMessage('err');
                            setRevertMessage("transaction failed");
                          }
                        });
                      }, 2000); // Check every 2 seconds
                    } else {
                      console.error("An error occurred:", response.status);
                    }
                  }).catch((error) => {             
                    console.error("An error occurred:", error.message);
                  });
                }}
                >claim</div>
              </div>
          </div>
      </div>
      <div className ="grid-item-claim" style={{alignItems: "center", justifyContent: "space-around", width:"90%", marginTop: "25px", marginLeft: "5%"}}>
        <div className="list-header"> 
        <div className="listview-header-grid" style={{width: "90%", marginLeft:"65px"}}>
        <div className="listview-grid-item">
          <span
          style={{color: '#9595ff'}}>
          Tile&nbsp;
          </span>
        </div>
          <div className="listview-grid-item" > 
          <span 
          style={{color: '#9595ff', marginLeft: "3em"}}>
              Class&nbsp;
            </span>
          </div>
        <div className="listview-grid-item">
          <span
          style={{color: '#9595ff',marginLeft: "5.8em"}}>        
              Pixels&nbsp;
            </span>
          </div>  
          <div className="listview-grid-item" > 
          <span
          style={{color: '#9595ff' , marginLeft: "2em"}}>
              Multiplier&nbsp;
            </span>
          </div>
          <div className="listview-grid-item" > 
          <span 
          style={{color: '#9595ff', marginLeft: "4.5em"}}>
              TPX&nbsp;
            </span>
        </div>
        </div>
        </div>
        <div className="tile-list-info-claim" style={{ marginBottom: "30px", height: items.length > 0 ? "300px" : "50px" }}>
        { currFetchingItems ? 
            (<div className="loading-container">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
              >
                <rect
                  className="spinner_9y7u"
                  x="1"
                  y="1"
                  rx="1"
                  width="10"
                  height="10"
                />
                <rect
                  className="spinner_9y7u spinner_DF2s"
                  x="1"
                  y="1"
                  rx="1"
                  width="10"
                  height="10"
                />
                <rect
                  className="spinner_9y7u spinner_q27e"
                  x="1"
                  y="1"
                  rx="1"
                  width="10"
                  height="10"
                />
              </svg>
            </div>)                  
          :
          (<>
          {items.length > 0 ? (
            <>
              <div className="scrollable">
                {items.map((item, index) => (
                  <div
                    className={`list-item clickable ${
                      item.name === selectedItem ? 'selected-list-item' : ''
                    }`}
                    style={{
                      backgroundColor:
                        itemsToClaim.includes(token_dict[item.name])  ? item.color : 'rgb(59, 49, 70, .6)',
                      // 'rgba(35, 38, 68)',
                      pointerEvents: 'all',
                      color:  "#dcdcdc",
                      border:
                        item.name === mousedOverItem ? '1px solid #ffed7a' : null,
                    }}
                    key={item.name}
                    onMouseEnter={() => {
                      setMousedOverItem(item.name);
                    }}
                    onMouseLeave={() => {
                      setMousedOverItem(null);
                    }}
                    onClick={() => {
                    }}

                  >
                    <img src={item.image} className="item-image" style={{marginRight: "-10%", opacity: itemsToClaim.includes(token_dict[item.name])  ?  1.0 : 0.2}}/>
                    <div className="item-name-info" style={{ opacity: itemsToClaim.includes(token_dict[item.name])  ?  1.0 : 0.2}}>{item.name}</div> 
                    <div className="item-name-info" style={{textAlign:"left", opacity: itemsToClaim.includes(token_dict[item.name])  ?  1.0 : 0.2}}>{polygonJson.features[0].features[parseInt(item.name)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1]}</div>
                    <div className="item-name-info" style={{display: 'flex', justifyContent: 'flex-end', opacity: itemsToClaim.includes(token_dict[item.name])  ?  1.0 : 0.2}}>{token_dict[item.name]}</div>
                    <div className="item-name-info" style={{textAlign:"right", opacity: itemsToClaim.includes(token_dict[item.name])  ?  1.0 : 0.2}}>
                    {
                      itemsToClaim.includes(token_dict[item.name])  ?  
                      (() => {
                        const match = polygonJson.features[0].features[parseInt(item.name)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1];
                        switch(match) {
                          case 'A':
                            return '0.004';
                          case 'B':
                            return '0.003';
                          case 'C':
                            return '0.002';
                          case 'D':
                            return '0.001';
                          default:
                            return ''; // Or any default value you wish to show
                        }
                      })()
                      : '-'
                    }
                    </div> 
                    <div className="item-name-info" style={{display: 'flex', textAlign:"right", justifyContent: 'flex-end', opacity: itemsToClaim.includes(token_dict[item.name])  ?  1.0 : 0.2}}>
                    {
                     itemsToClaim.includes(token_dict[item.name])  ?  
                      (() => {
                        const match = polygonJson.features[0].features[parseInt(item.name)].features[0].properties.name.match(/class([A-Za-z])-/)?.[1];
                        switch(match) {
                          case 'A':
                            return  Number(token_dict[item.name] * 0.004).toFixed(2);
                          case 'B':
                            return  Number(token_dict[item.name] *0.003).toFixed(2);
                          case 'C':
                            return Number(token_dict[item.name] * 0.002).toFixed(2);
                          case 'D':
                            return Number(token_dict[item.name] * 0.001).toFixed(2); 
                          default:
                            return ''; // Or any default value you wish to show
                        }
                      })()
                      : '-'
                    }
                    </div>
                  </div>
                ))}
              </div>
              <div id="list-footer-claim">
                <div style={{textAlign: "right", paddingTop: "6px", paddingBottom:"6px"}}> <span style={{color:"rgb(149, 149, 255)", fontFamily:'Terminus', fontSize: '16px',marginLeft: "433px", float: "left"}}>Total </span> <span style={{color: "#DCDCDC", fontFamily:'Terminus', fontSize: '1rem',marginRight: "31px"}}>{Number(totalClaim).toFixed(2)} </span></div> 
                <br style={{margin: "0em"}}></br>
                <div style={{borderTop: "rgba(154, 154, 154, 0.8) 1px solid", width: "100%", padding: "10px"}}>
                Summary: 
                {itemsToClaim.length > 0 && ` ${Number(totalClaim).toFixed(2)} TPX ready to claim from ${itemsToClaim.length} Tiles.`}
                {itemsFullList.length - itemsToClaim.length > 0 && ` ${itemsToClaim.length > 0 ? ' ' : ''}${Number(totalTPXforCalc - totalClaim).toFixed(2)} TPX already claimed from ${itemsFullList.length - itemsToClaim.length} Tiles.`}
                </div> 
              </div>
            </>
          ) : (
              <div className="scrollable" style={{display: "flex", height: "50px", justifyContent: "center", alignItems: "center"}}>
                <div style={{width: "100%", marginLeft: "10px", textAlign: "center"}}>
                { blockchain.account !== '' && blockchain.account !== null ? <> 
                  No Tiles in wallet </>
                  : <> No wallet connected </>}
                </div> 
              </div>
          )}
          </>
          )}
        </div>
      </div>
      </>
      ) : null}
      <h6 style={{marginLeft: "5%"}}>Intentions</h6>
      <div className ="grid-item-claim" style={{display: !DetectDevice ? "flex" : "block", alignItems: "center", justifyContent: "space-around", marginTop: "10px", marginBottom: "10px", 'z-index': "999"}}>
      <div id="claim_text" className={!DetectDevice ? "claim_text" : "claim_text_mobile"} style={{alignItems: "center", justifyContent: "space-around", fontSize: "15px"}}>
          <p> 
          Why did we create TPX? At 100K x 58K, <i>TODEM</i> has always been about the pixels. Or, more specifically, how many pixels are in each Tile. The number of pixels per Tile mirrors the 2022 distribution of wealth in the United States, and the Tiles are divided into four corresponding classes (A, B, C, D). The size of each Tile influences its image quality, where the image came from, and how much of Jason's focused handiwork (as opposed to algorithmic effort) went into it. 
          <br></br>
          TPX makes the pixel-oriented concepts participatory and tangible for <i>TODEM</i> holders and reinforces our thesis that bigger Tiles are (typically) better artworks. Future Latent Culture projects will be exclusively available to mint via TPX. For more, you can read about the technology and artistic intentions behind <i>TODEM</i> 
          
          <a
        href="https://www.latentculture.com/todem/info.art_tech"
        rel="noreferrer"
        target="_blank"
      >
        {' '}here
      </a> 
          <br style={{  margin: "1em", content: "none"}}></br>
          <br style={{  margin: "1em", content: "none"}}></br>
          </p>
      </div>
      </div>
      </div>
      </>
  );
}

export default Info_claim;
